import {TicketActionAvailableDto} from "../../../../../../model/dto/api/ticket-action-available.dto";

export class UiAvailableActions {
    label: string;
    actionType: number;
    availableActions: TicketActionAvailableDto[];
}